import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=244673cb&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=244673cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244673cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('244673cb')) {
      api.createRecord('244673cb', component.options)
    } else {
      api.reload('244673cb', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=244673cb&scoped=true&", function () {
      api.rerender('244673cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HKaCbPHhAIZY/JS/comp/PopupDialog.vue"
export default component.exports